import { useState } from "react";
import { Link } from "react-router-dom";
import { Linkedin, Instagram, Facebook, Twitter, Mail, Phone, } from "react-feather";  //when use form function uncomment handle & form, add send in this line.
import { motion } from "framer-motion";
import logo from "../../assets/images/logo.jpg";

const quickLinks = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/products", label: "Products" },
  { to: "/rudra-rides", label: "Rudra Ride" },
  { to: "/edupravahaa", label: "Edu Pravahaa" },
  { to: "/launch-event", label: "Launch Recap" },
  { to: "/contact", label: "Contact" },
];

const supportLinks = [
  { to: "/FAQ", label: "FAQ" },
  { to: "/PrivacyPolicy", label: "Privacy Policy" },
  { to: "/TermsConditions", label: "Terms & Conditions" },
  { to: "/services", label: "Services" },
];

export default function PremiumFooter() {
  // const [email, setEmail] = useState("");

  // const handleNewsletter = (e) => {
  //   e.preventDefault();
  //   if (email) {
  //     window.location.href = `mailto:hr@eptpravahaa.com?subject=Newsletter&body=Subscribe: ${encodeURIComponent(email)}`;
  //   }
  // };

  return (
    <footer className="relative bg-[#040d18] border-t border-white/10 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-t from-[#2563EB]/10 to-transparent pointer-events-none" />
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#F5C044]/50 to-transparent" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12">
          <div className="lg:col-span-2">
            {/* <div className="flex items-center gap-3 mb-4">
              <img src={logo} alt="EPT Pravahaa" className="h-12 w-12 rounded-xl ring-2 ring-[#2563EB]/40" />
              <div>
                <p className="font-bold text-white">EPT PRAVAHAA</p>
                <p className="text-[10px] text-[#F5C044] uppercase tracking-widest font-semibold">Edu Tech Solutions</p>
              </div>
            </div> */}
<div className="flex items-center gap-3 mb-4">
  <img src={logo} alt="EPT Pravahaa" className="h-12 w-12 rounded-xl ring-2 ring-[#2563EB]/40" />
  <div className="hidden md:block min-w-0 flex flex-col justify-center">
  <span 
    className="block text-white font-bold text-sm tracking-wide truncate"
    style={{ lineHeight: '1' }}
  >
    EPT PRAVAHAA
  </span>
  <span 
    className="block text-[9px] sm:text-[10px] text-[#F5C044]/90 uppercase tracking-[0.2em] font-semibold"
    style={{ lineHeight: '1', marginTop: '1px' }}
  >
    Edu Tech Solutions
  </span>
</div>
</div>
            <p className="text-white/55 text-sm leading-relaxed max-w-sm">
              Smart mobility, digital education, and scalable software — empowering the future through technology.
            </p>
            <div className="flex gap-3 mt-6">
              <a
                href="https://www.linkedin.com/company/eptpravahaa-edu-tech-solutions-private-limited/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2.5 rounded-xl premium-glass text-white/70 hover:text-white hover:border-[#2563EB]/40 transition-all"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
              <a
                href="https://www.instagram.com/reel/DQt1yqPDxIc/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2.5 rounded-xl premium-glass text-white/70 hover:text-white hover:border-[#F5C044]/40 transition-all"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://www.facebook.com/share/1Be91eGFhe/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2.5 rounded-xl premium-glass text-white/70 hover:text-white hover:border-[#2563EB]/40 transition-all"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href="#" // Replace with your Twitter URL
                target="_blank"
                rel="noopener noreferrer"
                className="p-2.5 rounded-xl premium-glass text-white/70 hover:text-white hover:border-[#2563EB]/40 transition-all"
                aria-label="Twitter"
              >
                <Twitter size={18} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-[#F5C044] text-xs font-bold uppercase tracking-widest mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-white/55 hover:text-white text-sm transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[#F5C044] text-xs font-bold uppercase tracking-widest mb-4">Support</h4>
            <ul className="space-y-2.5">
              {supportLinks.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-white/55 hover:text-white text-sm transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[#F5C044] text-xs font-bold uppercase tracking-widest mb-4">Newsletter</h4>
            <p className="text-white/50 text-sm mb-3">Stay updated on launch news & courses.</p>
            {/* <form onSubmit={handleNewsletter} className="flex gap-2">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                className="premium-input flex-1 !py-2.5 !text-sm"
              />
              <button type="submit" className="p-2.5 rounded-xl premium-cta-gold flex-shrink-0" aria-label="Subscribe">
                <Send size={18} />
              </button>
            </form> */}
            <div className="mt-6 space-y-2">
              <a href="tel:+919100241284" className="flex items-center gap-2 text-white/60 hover:text-white text-sm">
                <Phone size={14} /> +91 9100241284
              </a>
              <a href="mailto:hr@eptpravahaa.com" className="flex items-center gap-2 text-white/60 hover:text-white text-sm">
                <Mail size={14} /> hr@eptpravahaa.com
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/45 text-sm">
            © {new Date().getFullYear()} EPTPRAVAHAA EDU TECH SOLUTIONS — All Rights Reserved.
          </p>
          <motion.p
            animate={{ opacity: [0.7, 1, 0.7] }}
            transition={{ duration: 3, repeat: Infinity }}
            className="text-[#F5C044]/90 text-sm font-medium italic"
          >
            Powered by Innovation
          </motion.p>
        </div>
      </div>
    </footer>
  );
}
